import { Component, OnInit, Optional } from '@angular/core';
import { MmDialogRefService } from '@metromarkets/components';
import { EmployeeService } from '~app/modules/authorization/services/employee.service';
import { environment } from '~env/environment';
import { APP_EMPLOYEE_OVERVIEW } from '~shared/constants';
import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';

@Component({
  selector: 'app-employee-overview-navigation-alert-dialog',
  templateUrl: './employee-overview-navigation-alert-dialog.component.html',
  styleUrls: ['./employee-overview-navigation-alert-dialog.component.scss']
})
export default class EmployeeOverviewNavigationAlertDialogComponent {

  public advancedFormConfig: IAdvancedFormConfig;

  constructor(
    @Optional() public dialogRef: MmDialogRefService<any>,
    private employeeService: EmployeeService
    ) {
  }

  handleOverviewClick() {
    this.employeeService.stopImpersonatingCustomer(this.navigateToEmployeeOverview);
    this.dialogRef.close();
  }

  navigateToEmployeeOverview() {
    window.location.href = `/${environment.baseHref().replace(new RegExp('\/', 'g'), '')}/${APP_EMPLOYEE_OVERVIEW}`;
  }

  handleResumeSession() {
    this.dialogRef.close();
  }

}
